import { useQuery } from '@tanstack/react-query';
import type { ApiException } from '@/lib/api/types';
import { fetchAutoTradeConfig, fetchAutoTradeOrders } from './autoTradeApi';
import type { AutoTradeConfig, AutoTradeOrder } from './autoTradeTypes';

/**
 * 자동매매 조회 훅. (2026-09-20, BACKLOG I-5 A3)
 *
 * 갱신 주기를 짧게 두지 않는다 — 그림자 기록은 매매가 일어날 때만 늘고,
 * 저점매수는 하루 5~15건이다. 화면을 열어 둔 채 자주 읽어도 같은 값이다.
 */

/**
 * 30초. 30초 안에 다시 읽으면 캐시를 쓴다는 뜻이다.
 * 🔴 저절로 갱신되지는 않는다 - refetchInterval 이 없어 화면에 다시 들어오거나 창에 포커스가 돌아올 때 등
 *   TanStack Query 의 재조회 시점에만 새로 읽는다. (9/28 I-78 2차 - 전에는 "장중에 한 번쯤 갱신" 이라 적혀 있었다)
 */
const STALE_TIME = 30 * 1000;

export function useAutoTradeConfig(country = 'KR') {
  return useQuery<AutoTradeConfig | null, ApiException>({
    queryKey: ['trading', 'autotrade', 'config', country],
    queryFn: () => fetchAutoTradeConfig(country),
    staleTime: STALE_TIME,
  });
}

export function useAutoTradeOrders(days = 7) {
  return useQuery<AutoTradeOrder[], ApiException>({
    queryKey: ['trading', 'autotrade', 'orders', days],
    queryFn: () => fetchAutoTradeOrders(days),
    staleTime: STALE_TIME,
  });
}
